/* sb-dc-roundthumb.js — show round sticker templates as circles on the
   Design Templates page. 2026-09-04.

   The artwork for a die-cut sticker is a square file: the design fills the
   whole square and the press cuts the circle out of it. On the grid that reads
   as a square tile, so a customer picks a "round sticker" template, lands in
   the design center, and finds a circular artboard instead — the mismatch the
   store flagged.

   The page's own section builds those cards, and it is a 24 KB file we would
   have to rewrite whole to add one rule, so this rides alongside it instead:
   read which templates belong to round or oval stickers, then round off those
   thumbnails to match the cut.

   Only near-square artwork is rounded. An image is drawn with object-fit:
   contain, so a 10x8 file sits letterboxed inside its box and a 50% radius
   would bite into the design rather than trace it; those are left square and
   counted in window.__dcRoundThumb.skipped. */
(function () {
  'use strict';

  var STYLE_ID = 'sbdt-roundthumb-css';
  var round = null;          // Set of file_url for round/oval sticker templates
  var oval = new Set();      // 2026-10-02: file_url of oval-sticker templates — cut as an ellipse whatever the ratio
  var stats = { rounded: 0, skipped: 0, urls: 0 };
  window.__dcRoundThumb = stats;

  function css() {
    if (document.getElementById(STYLE_ID)) return;
    var st = document.createElement('style');
    st.id = STYLE_ID;
    st.textContent =
      '#sbdt-root .sbdt-thumb img.sbdt-round{border-radius:50%;background:#fff;' +
      'box-shadow:0 0 0 1px rgba(12,32,44,.08)}';
    document.head.appendChild(st);
  }

  function load() {
    var S = window.__dcSupabase;
    if (!S) return Promise.reject(new Error('no project config'));
    var url = S.url + '/rest/v1/dc_templates' +
      '?select=file_url,products&active=eq.true&or=(products.cs.{round-sticker},products.cs.{oval-sticker})';
    return fetch(url, { headers: { apikey: S.anonKey, Authorization: 'Bearer ' + S.anonKey } })
      .then(function (r) { return r.json(); })
      .then(function (rows) {
        round = new Set((rows || []).map(function (r) { return r.file_url; }));
        oval = new Set((rows || []).filter(function (r) { return (r.products || []).indexOf('oval-sticker') >= 0; }).map(function (r) { return r.file_url; }));
        stats.urls = round.size;
      });
  }

  function sweep() {
    if (!round || !round.size) return;
    var imgs = document.querySelectorAll('#sbdt-root .sbdt-thumb img');
    for (var i = 0; i < imgs.length; i++) {
      var im = imgs[i];
      if (im.dataset.sbdtRound) continue;
      if (!round.has(im.src)) continue;
      /* Wait for the file: the aspect ratio decides whether rounding is safe,
         and a lazy image has no dimensions until it loads. */
      if (!im.complete || !im.naturalWidth) continue;
      im.dataset.sbdtRound = '1';
      var ratio = im.naturalWidth / im.naturalHeight;
      if (Math.abs(ratio - 1) < 0.05 || oval.has(im.src)) { im.classList.add('sbdt-round'); stats.rounded++; }
      else stats.skipped++;
    }
  }

  function start() {
    css();
    load().then(function () {
      sweep();
      /* The grid rebuilds itself on every filter change, and lazy images
         arrive whenever they arrive, so keep checking rather than hooking
         either one. */
      var root = document.getElementById('sbdt-root');
      if (root && window.MutationObserver) {
        new MutationObserver(function () { sweep(); }).observe(root, { childList: true, subtree: true });
      }
      var t = setInterval(sweep, 500);
      window.addEventListener('pagehide', function () { clearInterval(t); });
    }).catch(function () { /* leave the grid exactly as it was */ });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
